export const today = (): string => new Date().toLocaleDateString("en-CA");

export const daysAgo = (n: number): string => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toLocaleDateString("en-CA");
};

export const isoDate = (raw: string): string | null => {
  if (!raw) return null;
  const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? m[0] : null;
};
